module.exports = __webpack_public_path__ + "static/media/Plan_de_accion.ad640f71.png";